/**
 * El stock de un producto y su libreta, dentro del detalle (INV-01).
 *
 * El numero no se edita: se anota que paso y el numero sale de ahi
 * (`FormularioMovimiento` explica por que). Debajo van los ultimos movimientos
 * de ESTE producto, que es donde se contesta "por que quedan 95 y no 100".
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { usePeticion } from '../../hooks/use-peticion';
import { obtenerMovimientos } from '../../servicios/administracion.servicio';
import { numero } from '../../utilidades/formato';
import { rutas } from '../../utilidades/rutas';
import { AvisoError } from '../comunes/EstadoPeticion';
import { FormularioMovimiento, type ProductoDelMovimiento } from './FormularioMovimiento';
import { Modal } from './Modal';
import { PanelAdmin } from './PanelAdmin';
import { TablaMovimientos } from './TablaMovimientos';

/** Los ultimos, no todos: la libreta completa esta en Inventario. */
const MOVIMIENTOS_VISIBLES = 8;

export interface PanelStockProductoProps {
  producto: ProductoDelMovimiento;
  onStockCambiado(stock: number): void;
}

export function PanelStockProducto({ producto, onStockCambiado }: PanelStockProductoProps) {
  const [anotando, setAnotando] = useState(false);

  const movimientos = usePeticion(
    (senal) =>
      obtenerMovimientos({ productoId: producto.id, porPagina: MOVIMIENTOS_VISIBLES }, senal),
    // El stock cambia con cada movimiento: es la senal para volver a pedirlos.
    [producto.id, producto.stock],
  );

  return (
    <PanelAdmin
      titulo="Stock"
      bajada={
        producto.stock > 0
          ? `${numero(producto.stock)} ${producto.stock === 1 ? 'unidad' : 'unidades'} en inventario`
          : 'Agotado'
      }
      extra={
        <button type="button" className="btn btn-sm btn-primario" onClick={() => setAnotando(true)}>
          Anotar movimiento
        </button>
      }
    >
      {movimientos.estado === 'error' ? <AvisoError error={movimientos.error} /> : null}

      {movimientos.datos !== null ? (
        <>
          <TablaMovimientos movimientos={movimientos.datos.items} sinProducto />
          {movimientos.datos.total > MOVIMIENTOS_VISIBLES ? (
            <p className="parrafo-panel">
              <Link to={rutas.administracion.inventario()}>Ver la libreta completa en Inventario</Link>
            </p>
          ) : null}
        </>
      ) : null}

      <Modal
        titulo="Anotar un movimiento"
        bajada={producto.nombre}
        abierto={anotando}
        onCerrar={() => setAnotando(false)}
      >
        {anotando ? (
          <FormularioMovimiento
            producto={producto}
            onCancelar={() => setAnotando(false)}
            onAnotado={(movimiento) => {
              setAnotando(false);
              onStockCambiado(movimiento.stockResultante);
            }}
          />
        ) : null}
      </Modal>
    </PanelAdmin>
  );
}
